import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { exportCollectionPointSchemaObject } from '../exportReSyncSchema'
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import { MenuItem, FormHelperText, TextField } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'RESYNCTRANSACTIONS';


export function RegularCollectionPointAddEdit(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Add ReSync Transaction");
    const [buttonName, setButtonName] = useState("Save");
    const [groups, setGroups] = useState();
    const [collectionPoint, setCollectionPoint] = useState();
    const [collectionPointCategory, setCollectionPointCategory] = useState();
    const [isChanged, setIsChanged] = useState(0);
    const [operationEntity, setOperationEntity] = useState();
    const [selectedCollectionpoint, setSelectedCollectionpoint] = useState();
    const [errors, setErrors] = useState({});
    const schema = Joi.object(exportCollectionPointSchemaObject).options({ allowUnknown: true });
    const [exportcollectionpoint, setExportcollectionpoint] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionCategoryID: "0",
        collectionPointCategoryID: "0",
        collectionPointCode: '',
        collectionPointName: '',
        collectionPointLocation: '',
        isActive: true,

    });

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    useEffect(() => {
        getPermissions();
        getCollectionPointCategoryDropDown();
    }, []);

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [exportcollectionpoint]);

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [exportcollectionpoint.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionpointDropDownData()
        )
    }, [exportcollectionpoint.operationEntityID]);

    function handleChange(e) {
        const target = e.target;
        const value = target.name === 'isActive' ? target.checked : target.value;

        if (target.name === "collectionPointCode") {
            if (target.value.length === 3) return false
        }

        const error = { ...errors };
        const errorMessage = validateProperty(target, exportCollectionPointSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setExportcollectionpoint({
            ...exportcollectionpoint,
            [e.target.name]: value
        });
        setErrors(error);
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/reSyncTransaction' })
            }, 1500);
        }
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setExportcollectionpoint({
            ...exportcollectionpoint,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionCategoryID: "0",
            collectionPointCode: '',
            collectionPointName: '',
            collectionPointLocation: '',
            isActive: true
        });
        setErrors('');
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function handleGroupDropdown(target) {
        validateInputs(target);

        setExportcollectionpoint({
            ...exportcollectionpoint,
            groupID: target.value,
            operationEntityID: '0',
            collectionCategoryID: '0',
            collectionPointCategoryID: '0'
        });
    }

    function handleOperationEntityDropdown(target) {
        validateInputs(target);

        setExportcollectionpoint({
            ...exportcollectionpoint,
            operationEntityID: target.value,
            collectionCategoryID: '0',
            collectionPointCategoryID: '0'
        });
    }

    function handleCollectionPointChange(target) {
        validateInputs(target);

        setExportcollectionpoint({
            ...exportcollectionpoint,
            collectionCategoryID: target.value,
            collectionPointCategoryID: '0'
        });
    }

    function handleCollectionPointCategoryDropDown(target) {
        validateInputs(target);

        setExportcollectionpoint({
            ...exportcollectionpoint,
            collectionPointCategoryID: target.value
        })
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, exportCollectionPointSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITRESYNCTRANSACTIONS');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        if (data && edit) {
            setTitle("Edit ReSync Transaction");
            setExportcollectionpoint(data);
            fillCollectionPointsValues(data);
            setButtonName("Update");
        } else {
            setTitle("Add ReSync Transaction");
            var token = tokenService.getUserDetailsFromToken();
            setExportcollectionpoint({
                ...exportcollectionpoint,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getAllDropDownData(),
            getOperationEntities()
        )
    }

    async function fillCollectionPointsValues(data) {

        const collectionPointData = await services.getCollectionPointByID(data.collectionPointID);
        setSelectedCollectionpoint(collectionPointData);

        const collectionPoint = await services.GetCollectionCategoryByOperationEntityID(collectionPointData.operationEntityID.toString());
        setCollectionPoint(collectionPoint);

        const operationEntity = await services.GetAllOperationEntityByGroupID(collectionPointData.groupID.toString());
        setOperationEntity(operationEntity);

        setExportcollectionpoint({
            ...data,
            operationEntityID: collectionPointData.operationEntityID.toString(),
            collectionCategoryID: collectionPointData.collectionCategoryID.toString(),
            collectionPointCode: data.collectionPointCode.toString(),
            collectionPointName: data.collectionPointName.toString(),
            collectionPointLocation: data.collectionPointLocation.toString(),
            isActive: data.isActive
        });
    }

    async function getAllDropDownData() {
        const group = await groupService.getGroupsForDropdown();
        setGroups(group);
    }

    async function getCollectionpointDropDownData() {
        const collectionPoint = await services.GetCollectionCategoryByOperationEntityID(exportcollectionpoint.operationEntityID);
        setCollectionPoint(collectionPoint);
    }

    async function getOperationEntities() {
        const operationEntity = await services.GetAllOperationEntityByGroupID(exportcollectionpoint.groupID);
        setOperationEntity(operationEntity);
    }

    async function getCollectionPointCategoryDropDown() {
        const collectionPointCategory = await services.getCollectionPointCategories();
        setCollectionPointCategory(collectionPointCategory);
    }

    async function handleSave(e) {
        e.preventDefault();


        if (!edit) {
            const response = await services.saveRegularCollectionPoint(exportcollectionpoint);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode);
        } else {
            const response = await services.editData(exportcollectionpoint);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode);
        }
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/reSyncTransaction"
                                    isChanged={isChanged}
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSave(e)}>

                                <div className="row row-top-gap">
                                    <div className="col-md">
                                        <InputLabel shrink id="GroupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            id="groupID"
                                            name="groupID"
                                            value={exportcollectionpoint.groupID}
                                            onChange={(e) => handleGroupDropdown(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={exportcollectionpoint.operationEntityID}
                                            onChange={(e) => handleOperationEntityDropdown(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="collectionCategoryID">Collection Category *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionCategoryID"
                                            name="collectionCategoryID"
                                            value={exportcollectionpoint.collectionCategoryID}
                                            onChange={(e) => handleCollectionPointChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Category--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                        {errors["collectionCategoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionCategoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionPointCategoryID">CollectionPoint Category * </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointCategoryID"
                                            id="collectionPointCategoryID"
                                            name="collectionPointCategoryID"
                                            value={exportcollectionpoint.collectionPointCategoryID}
                                            onChange={(e) => handleCollectionPointCategoryDropDown(e.target)}
                                        >
                                            <MenuItem value="0">--Select CollectionPoint Category--</MenuItem>
                                            {generateDropDownMenu(collectionPointCategory)}
                                        </Select>
                                        {errors["collectionPointCategoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointCategoryID"]}</FormHelperText>}

                                    </div>


                                </div>

                                <div className="row row-top-gap">
                                    <div className="col-md">
                                        <div className="form-group">
                                            <InputLabel>Collection Point Code *</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                maxLength="2"
                                                value={exportcollectionpoint.collectionPointCode}
                                                name="collectionPointCode"
                                                id="collectionPointCode"
                                                onChange={handleChange}
                                            />
                                            {errors["collectionPointCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointCode"]}</FormHelperText>}
                                        </div>
                                    </div>

                                    <div className="col-md">
                                        <div className="form-group">
                                            <InputLabel>Collection Point Name *</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="text"
                                                value={exportcollectionpoint.collectionPointName}
                                                name="collectionPointName"
                                                id="collectionPointName"
                                                onChange={handleChange}
                                            />
                                            {errors["collectionPointName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointName"]}</FormHelperText>}
                                        </div>
                                    </div>

                                    <div className="col-md">
                                        <div className="form-group">
                                            <InputLabel>Collection Point Location</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="text"
                                                value={exportcollectionpoint.collectionPointLocation}
                                                name="collectionPointLocation"
                                                id="collectionPointLocation"
                                                onChange={handleChange}
                                            />
                                            {errors["collectionPointLocation"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointLocation"]}</FormHelperText>}
                                        </div>
                                    </div>

                                </div>

                                <label>Active</label>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            className="mr-2"
                                            id="isActive"
                                            switch="none"
                                            type="checkbox"
                                            name="isActive"
                                            onChange={(e) => handleChange(e)}
                                            checked={exportcollectionpoint.isActive}
                                        />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No">
                                        </label>
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonName}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>)
}